import { useAppSelector } from '@store';
import AmlGeneralInfoWrapper from '../../partial/aml/general-info';
import AmlGeneralInfoRow from '../../partial/aml/general-info-row';
import { AMLGeneralInfoTypes } from '../types';

const AmlGeneralInfo = ({
  isLoading,
  baseInformation,
  nextReviewDate,
  auditLogAllowed,
  setChangeLogPanelIsOpen,
}: AMLGeneralInfoTypes): React.JSX.Element => {
  const { clientsActivities } = useAppSelector(
    (state) => state.customersDictionaries,
  );

  return (
    <AmlGeneralInfoWrapper
      title="Employment status"
      isLoading={isLoading}
      nextReviewDate={nextReviewDate}
      auditLogAllowed={auditLogAllowed}
      setChangeLogPanelIsOpen={setChangeLogPanelIsOpen}
    >
      <AmlGeneralInfoRow
        title="Status"
        value={
          clientsActivities?.find(
            (item) => item.value === baseInformation?.clientActivityId,
          )?.name
        }
      />
    </AmlGeneralInfoWrapper>
  );
};

export default AmlGeneralInfo;
